module.exports = __webpack_public_path__ + "static/media/06.d80f8069.jpg";